// extracted by mini-css-extract-plugin
export default {"recoveryHash":"recoveryHash_recoveryHash__WmgMu","title":"recoveryHash_title__XLTGQ","content":"recoveryHash_content__WCmli","logo":"recoveryHash_logo__D169P"};